import { Alert } from 'hljd'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import styles from './style.module.less'

@inject('store')
@observer
class TopAlert extends Component {
  render() {
    const {
      store: { form_init }
    } = this.props
    const form_default = toJS(form_init)

    return (
      !!form_default?.report && (
        <div className={styles.topAlert}>
          <Alert
            message={`该案例被举报，正在审核处理中，暂时无法修改案例，如对举报有异议请联系客服 400-159-9090`}
            type="error"
            showIcon
          />
          <div className={styles.preventMask} />
        </div>
      )
    )
  }
}

export default TopAlert
